module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-2.4271d20c.png";